var exports = {
  "kL": "x7be19a29--90b310--container",
  "FF": "x7be19a29--90b310--thumb",
  "PM": "x7be19a29--90b310--thumb--active",
  "Sl": "x7be19a29--90b310--image",
};

module.exports = exports;
